// src/components/MyFooter.jsx
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaw } from "@fortawesome/free-solid-svg-icons";
import { faTwitter, faTiktok, faInstagram } from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

const MyFooter = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="lpp-footer">
      <div className="lpp-footer-accent" />

      <Container className="lpp-footer-inner">
        <Row className="align-items-center gy-3">
          {/* Left: Brand line */}
          <Col
            xs={12}
            md={4}
            className="d-flex align-items-center justify-content-center justify-content-md-start"
          >
            <div className="lpp-footer-brand">
              <FontAwesomeIcon icon={faPaw} className="me-2" />
              <span>Little Paws Place™</span>
            </div>
          </Col>

          {/* Middle: Nav links */}
          <Col
            xs={12}
            md={4}
            className="d-flex justify-content-center lpp-footer-links"
          >
            <a href="/about">About</a>
            <a href="/contact-support">Contact</a>
            <a href="/terms">Terms</a>
            <a href="/privacy-policy">Privacy</a>
          </Col>

          {/* Right: Social + year */}
          <Col
            xs={12}
            md={4}
            className="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-center lpp-footer-right"
          >
            <div className="lpp-footer-social mb-2 mb-md-0 me-md-3">
              <a
                href="https://www.tiktok.com/@littlepawsplaces"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTiktok} />
              </a>
              <a
                href="https://twitter.com/littlepawsplace"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a
                href="https://www.instagram.com/littlepawsplace/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
            <div className="lpp-footer-copy">
              © {year} Little Paws Place
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default MyFooter;
